// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__31Hgu","questions":"styles_questions__3_g9K","footer":"styles_footer__2sgse"};